const rsaIdSchema = {
  id: "/properties/rsaId",
  type: "string",
  minLength: 13,
  maxLength: 13
};

const commonSchemas = {
  rsaId: rsaIdSchema,
};

export default commonSchemas;



// WEBPACK FOOTER //
// ./src/common/formValidation/common.schema.js